import React, { useState, useContext } from 'react';
import styled from 'styled-components';

import Icon from '../../misc/Icon';
import Accordion from '../../misc/Accordion';

import FileViews from '../../../constants/FileViews';

import ThemeIcons from '../../../theme/Icons';
import ThemeContext from '../../../theme/ThemeContext';
import CollectionEditor from './CollectionEditorv2';

const StyledAccordionContent = styled.div`
  display: relative;
  display: flex;
  flex-direction: row;
  flex: 1;
  padding: 8px;
`;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 0px;
`;

const StyledLabel = styled.label`
  font-weight: 600;
  font-size: 14px;
  color: gray8;
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width:${(props) => (props.view === FileViews.mobile ? '280px' : '480px')};
  color: ${(props) => props.theme.fontPrimaryColor || 'black'};
  svg {
    color: ${(props) => props.theme.fontPrimaryColor || 'black'} !important;
    font-size: 15px;
  }
`;

const StyledLabelIcon = styled.span`
  margin-right: 2px;
`;

const StyledDescription = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: ${(props) => props.theme.fontColorSecondary || 'gray'};
`;

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.borderColor || 'gray'};
  border-radius: ${(props) => props.theme.borderRadius || 4}px;
  overflow: auto;
  padding: 8px;
  width: 100%;
`;

const CollectionEditorSettings = (props) => {

  const { activeFieldPosition, onChange, onColumnEdit, onSchemaEdit, fieldSettings, features } = props;
  const { field, identifier, _id, schema, fieldPositionSchema } = activeFieldPosition;


  const theme = useContext(ThemeContext);
  const [open, setOpen] = useState(true);

  return (
    <Accordion
      isOpen={open}
      height={400}
      enforceHeight
      onClick={() => setOpen(!open)}
      title={(
        <StyledHeader>
          <StyledLabel theme={theme}>
            <StyledLabelIcon><Icon icon={ThemeIcons.settings.settings} size="lg" /></StyledLabelIcon>
            {' '}
            {'Structure'}
          </StyledLabel>
          <StyledDescription theme={theme}>
            Structure view is what is used to build the schema portion of the field
          </StyledDescription>
        </StyledHeader>
      )}
    >
      <StyledAccordionContent>
        <StyledWrapper theme={theme}>
          <CollectionEditor
            schema={schema}
            fieldPositionSchema={fieldPositionSchema}
            onChange={(schema) => onChange(field, identifier, _id, { schema })}
            onColumnEdit={(columnId, schemaId) => onColumnEdit(field, columnId, schemaId)}
            onSchemaEdit={(schemaId) => onSchemaEdit(schemaId)}
            fieldSettings={fieldSettings}
            features={features}
            fieldId={field}
          />
        </StyledWrapper>
      </StyledAccordionContent>
    </Accordion>
  );
};

export default CollectionEditorSettings;
